export const SIDE_SHEET_HEADER_HEIGHT = 40;
export const SIDE_SHEET_OFFSET = 24;
export const FULL_SCREEN_SHEET_OFFSET = -10;
export const NON_TAB_BAR_OFFSET = 10;

export const SIDE_SHEET_ELEMENT_NAME = 'detail-page-info-overlay-side-sheet';
export const FULL_SCREEN_SHEET_ELEMENT_NAME = 'detail-page-info-overlay-full-screen-sheet';

export const OVERLAY_CLOSE_DELAY = 500;

export const DETAIL_PAGE_HEADER_AND_SEARCH_BAR_HEIGHT = 120;
